import { render } from "./MutilSelectControl.vue?vue&type=template&id=2466be19"
import script from "./MutilSelectControl.vue?vue&type=script&lang=js"
export * from "./MutilSelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MutilSelectControl.vue"]])

export default __exports__